import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    ArrowsClockwiseIcon,
    DotsThreeIcon,
    FilePdfIcon,
    TrashIcon,
} from '@phosphor-icons/react';
import { Dropdown } from '@origo/origo-ui';
import type { DocumentItem } from '../../../types';
import styles from './DocumentList.module.css';

export type DocumentAction = 'replace' | 'delete';

interface DocumentListProps {
    items: DocumentItem[];
    onOpen: (id: string) => void;
    onAction: (action: DocumentAction, id: string) => void;
}

const DocumentList: React.FC<DocumentListProps> = ({ items, onOpen, onAction }) => {
    const { t } = useTranslation();

    return (
        <ul className={styles.list}>
            {items.map(item => (
                <li key={item.id}>
                    <div className={styles.row}>
                        <button
                            type="button"
                            className={styles.rowMain}
                            onClick={() => onOpen(item.id)}
                            aria-label={item.dokumentnavn}
                        >
                            <span className={styles.icon} aria-hidden="true">
                                <FilePdfIcon size={24} weight="duotone" />
                            </span>
                            <span className={styles.text}>
                                <span className={styles.title}>{item.dokumentnavn}</span>
                                <span className={styles.meta}>
                                    <span className={styles.metaType}>{item.dokumenttype}</span>
                                    {item.dato && <span className={styles.metaDate}>{item.dato}</span>}
                                </span>
                            </span>
                        </button>
                        <Dropdown
                            align="end"
                            className={styles.menu}
                            trigger={<DotsThreeIcon size={16} weight="bold" />}
                            groups={[
                                {
                                    items: [
                                        {
                                            id: 'replace',
                                            label: t('documents.actions.replace'),
                                            icon: <ArrowsClockwiseIcon size={16} weight="duotone" />,
                                            onClick: () => onAction('replace', item.id),
                                        },
                                        {
                                            id: 'delete',
                                            label: t('documents.actions.delete'),
                                            icon: <TrashIcon size={16} weight="duotone" />,
                                            danger: true,
                                            onClick: () => onAction('delete', item.id),
                                        },
                                    ],
                                },
                            ]}
                        />
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default DocumentList;
